import type { WorkspaceResponseV2 } from '@emma/api_client/types';
import { Box } from '@lego/klik-ui';
import {
  IncomingDeviceTransferTable,
  OutgoingDeviceTransferTable,
} from '@/components/device_transfer';

type Props = {
  workspace: WorkspaceResponseV2;
};

export const WorkspaceDeviceTransfersSubPage = (props: Props) => {
  return (
    <Box display="flex" flexDirection="column" gap={6}>
      <IncomingDeviceTransferTable workspace={props.workspace} />
      <OutgoingDeviceTransferTable workspace={props.workspace} />
    </Box>
  );
};
